import { render } from "./AccentButton.vue?vue&type=template&id=5d179bd7"
import script from "./AccentButton.vue?vue&type=script&lang=js"
export * from "./AccentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__